import { Injectable, NgModule, Component, Input, defineInjectable } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class Angular2CsvService {
    constructor() { }
}
Angular2CsvService.ɵfac = function Angular2CsvService_Factory(t) { return new (t || Angular2CsvService)(); };
Angular2CsvService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: Angular2CsvService, factory: Angular2CsvService.ɵfac, providedIn: 'root' });
/** @nocollapse */
Angular2CsvService.ctorParameters = () => [];
/** @nocollapse */ Angular2CsvService.ngInjectableDef = defineInjectable({ factory: function Angular2CsvService_Factory() { return new Angular2CsvService(); }, token: Angular2CsvService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Angular2CsvService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class Angular2CsvComponent {
    constructor() {
        this.filename = this.filename || 'mycsv.csv';
        this.options = this.objectAssign({}, ConfigDefaults, this.options);
        this.label_btn = "download";
        this.csv = '';
    }
    /**
     * Event Download
     * @return {?}
     */
    onDownload() {
        this.generateCsv();
    }
    /**
     * ngOnInit
     * @return {?}
     */
    ngOnInit() { }
    /**
     * [generateCsv description]
     * @return {?}
     */
    generateCsv() {
        if (this.options.useBom) {
            this.csv += CsvConfigConsts.BOM;
        }
        if (this.options.showTitle) {
            this.csv += this.options.title + '\r\n\n';
        }
        this.getHeaders();
        this.getBody();
        if (this.csv === '') {
            console.log('Invalid data');
            return;
        }
        let /** @type {?} */ blob = new Blob([this.csv], { type: 'text/csv;charset=utf8;' });
        if (navigator.msSaveBlob) {
            let /** @type {?} */ filename = this.options.filename.replace(/ /g, '_') + '.csv';
            navigator.msSaveBlob(blob, filename);
        }
        else {
            let /** @type {?} */ uri = 'data:attachment/csv;charset=utf-8,' + encodeURI(this.csv);
            let /** @type {?} */ link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('visibility', 'hidden');
            link.download = this.filename.replace(/ /g, '_') + '.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        this.csv = '';
    }
    /**
     * Create Headers for Csv File
     * @return {?}
     */
    getHeaders() {
        if (this.options.headers.length > 0) {
            let /** @type {?} */ row = '';
            for (let /** @type {?} */ column of this.options.headers) {
                row += column + this.options.fieldSeparator;
            }
            row = row.slice(0, -1);
            this.csv += row + CsvConfigConsts.EOL;
        }
    }
    /**
     * Create Headers
     * @return {?}
     */
    getBody() {
        for (let /** @type {?} */ dataRow of this.data) {
            let /** @type {?} */ row = '';
            if (this.isEmptyObject(dataRow) && this.options.removeNewLines) {
                continue;
            }
            if (typeof this.options.keys !== 'undefined' && this.options.keys.length) {
                for (let /** @type {?} */ key of this.options.keys) {
                    row += this.formartData(dataRow[key]) + this.options.fieldSeparator;
                }
                row = row.slice(0, -1);
                this.csv += row + CsvConfigConsts.EOL;
            }
            else {
                for (let /** @type {?} */ key in dataRow) {
                    if (dataRow[key]) {
                        row += this.formartData(dataRow[key]) + this.options.fieldSeparator;
                    }
                }
                this.csv += row + CsvConfigConsts.EOL;
            }
        }
    }
    /**
     * Format Data
     * @param {?} data
     * @return {?}
     */
    formartData(data) {
        if (this.options.decimalseparator === 'locale' && this.isFloat(data)) {
            return data.toLocaleString();
        }
        if (this.options.decimalseparator !== '.' && this.isFloat(data)) {
            return data.toString().replace('.', this.options.decimalseparator);
        }
        if (typeof data === 'string') {
            data = data.replace(/"/g, '""');
            if (this.options.quoteStrings || data.indexOf(',') > -1 || data.indexOf("\n") > -1 || data.indexOf("\r") > -1) {
                data = this.options.quoteStrings + data + this.options.quoteStrings;
            }
            return data;
        }
        if (typeof data === 'boolean') {
            return data ? 'TRUE' : 'FALSE';
        }
        return data;
    }
    /**
     * Validate if object is not empty
     * @param {?} obj
     * @return {?}
     */
    isEmptyObject(obj) {
        return (obj && (Object.keys(obj).length === 0));
    }
    /**
     * Get Input is Float
     * @param {?} input
     * @return {?}
     */
    isFloat(input) {
        return +input === input && (!isFinite(input) || Boolean(input % 1));
    }
    /**
     * Add object Values
     * @param {?} val
     * @return {?}
     */
    toObject(val) {
        if (val === null || val === undefined) {
            throw new TypeError('Object.assign cannot be called with null or undefined');
        }
        return Object(val);
    }
    /**
     * Add Values to Object
     * @param {?} target
     * @param {...?} source
     * @return {?}
     */
    objectAssign(target, ...source) {
        let /** @type {?} */ from;
        let /** @type {?} */ to = this.toObject(target);
        let /** @type {?} */ symbols;
        let /** @type {?} */ hasOwnProperty = Object.prototype.hasOwnProperty;
        let /** @type {?} */ propIsEnumerable = Object.prototype.propertyIsEnumerable;
        for (let /** @type {?} */ s = 1; s < arguments.length; s++) {
            from = Object(arguments[s]);
            for (let /** @type {?} */ key in from) {
                if (hasOwnProperty.call(from, key)) {
                    to[key] = from[key];
                }
            }
            if ((/** @type {?} */ (Object)).getOwnPropertySymbols) {
                symbols = (/** @type {?} */ (Object)).getOwnPropertySymbols(from);
                for (let /** @type {?} */ symbol of symbols) {
                    if (propIsEnumerable.call(from, symbol)) {
                        to[symbol] = from[symbol];
                    }
                }
            }
        }
        return to;
    }
}
Angular2CsvComponent.ɵfac = function Angular2CsvComponent_Factory(t) { return new (t || Angular2CsvComponent)(); };
Angular2CsvComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: Angular2CsvComponent, selectors: [["angular2csv"]], inputs: { filename: "filename", options: "options", data: "data" }, decls: 2, vars: 1, consts: [[3, "click"]], template: function Angular2CsvComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function Angular2CsvComponent_Template_button_click_0_listener() { return ctx.onDownload(); });
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label_btn);
    } }, encapsulation: 2 });
/** @nocollapse */
Angular2CsvComponent.ctorParameters = () => [];
Angular2CsvComponent.propDecorators = {
    data: [{ type: Input }],
    filename: [{ type: Input }],
    options: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Angular2CsvComponent, [{
        type: Component,
        args: [{ selector: 'angular2csv', template: `<button (click)="onDownload()">{{ label_btn }}</button>` }]
    }], function () { return []; }, { filename: [{
            type: Input
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();
/**
 * CsvConfigConsts
 */
class CsvConfigConsts {
}
CsvConfigConsts.EOL = '\r\n';
CsvConfigConsts.BOM = '\ufeff';
CsvConfigConsts.DEFAULT_FIELD_SEPARATOR = ',';
CsvConfigConsts.DEFAULT_DECIMAL_SEPARATOR = '.';
CsvConfigConsts.DEFAULT_QUOTE = '"';
CsvConfigConsts.DEFAULT_SHOW_TITLE = false;
CsvConfigConsts.DEFAULT_TITLE = 'My Report';
CsvConfigConsts.DEFAULT_FILENAME = 'mycsv.csv';
CsvConfigConsts.DEFAULT_SHOW_LABELS = false;
CsvConfigConsts.DEFAULT_USE_BOM = true;
CsvConfigConsts.DEFAULT_HEADER = [];
CsvConfigConsts.DEFAULT_KEY = [];
CsvConfigConsts.DEFAULT_REMOVE_NEW_LINES = false;
/**
 * Default Configurations
 */
const /** @type {?} */ ConfigDefaults = {
    filename: CsvConfigConsts.DEFAULT_FILENAME,
    fieldSeparator: CsvConfigConsts.DEFAULT_FIELD_SEPARATOR,
    quoteStrings: CsvConfigConsts.DEFAULT_QUOTE,
    decimalseparator: CsvConfigConsts.DEFAULT_DECIMAL_SEPARATOR,
    showLabels: CsvConfigConsts.DEFAULT_SHOW_LABELS,
    showTitle: CsvConfigConsts.DEFAULT_SHOW_TITLE,
    title: CsvConfigConsts.DEFAULT_TITLE,
    useBom: CsvConfigConsts.DEFAULT_USE_BOM,
    headers: CsvConfigConsts.DEFAULT_HEADER,
    keys: CsvConfigConsts.DEFAULT_KEY,
    removeNewLines: CsvConfigConsts.DEFAULT_REMOVE_NEW_LINES
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class Angular2CsvModule {
}
Angular2CsvModule.ɵfac = function Angular2CsvModule_Factory(t) { return new (t || Angular2CsvModule)(); };
Angular2CsvModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: Angular2CsvModule });
Angular2CsvModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Angular2CsvModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [Angular2CsvComponent],
                exports: [Angular2CsvComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(Angular2CsvModule, { declarations: function () { return [Angular2CsvComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [Angular2CsvComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { Angular2CsvService, Angular2CsvComponent, CsvConfigConsts, ConfigDefaults, Angular2CsvModule };

